<!--
 * @Author: zhangyue zhang_y1222@163.com
 * @Date: 2023-03-30 17:24:00
 * @LastEditors: zhangyue zhang_y1222@163.com
 * @LastEditTime: 2023-10-19 10:05:35
 * @FilePath: \rhzx_zhxy\src\components\Footer.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <van-tabbar v-model="activeTab"
              @change="onChange"
              active-color="#009b5d"
              inactive-color="#fff"
              class="footer"
              fixed>
    <van-tabbar-item>
      <span class="text">考勤数据</span>
      <template #icon>
        <van-icon name="todo-list-o"
                  class="text icon_size toDo"></van-icon>
      </template>
    </van-tabbar-item>
    <van-tabbar-item>
      <span class="text">我的</span>
      <template #icon>
        <van-icon class="text icon_size"
                  class-prefix="my-icon"
                  name="my"></van-icon>
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['userInfo']),
  },
  props: {
    active: {
      type: Number,
    },
  },
  data () {
    return {
      reportPath: '',
      activeTab: 0,
    }
  },
  created () {
    this.activeTab = this.active
  },
  methods: {
    onChange (activeTab) {
      if (activeTab === 0) {
        this.$router.push('/student')
      }
      if (activeTab === 1) {
        this.$router.push('/myCenter')
      }
    },
  },
}
</script>

<style scoped lang="less">
.footer {
  box-shadow: inset 0 0 0.00625rem #ccc;
  border-top: 1px solid #ccc;
  height: 60px;
  // z-index: 99;
  .icon_size {
    font-size: 25px !important;
  }
  ::v-deep .van-tabbar-item__icon {
    margin-bottom: 8px;
  }
  .text {
    color: #000;
    font-size: 13px;
  }
  .toDo {
    color: #999;
  }
  ::v-deep .van-tabbar-item--active {
    .text {
      color: @green;
    }
    .my-icon-mailList:before {
      color: @green;
    }
    .my-icon-staging:before {
      color: @green;
    }
    .my-icon-my:before {
      color: @green;
    }
  }
}
</style>
